// extracted by mini-css-extract-plugin
module.exports = {"plan":"PlanPanel_plan__3vcMj","plan__nav":"PlanPanel_plan__nav__3P_4A","plan__main":"PlanPanel_plan__main__1BJPQ","plan__study":"PlanPanel_plan__study__1QnbO"};